/**
 * User role enumeration
 * Defines the roles available in the application
 */
export enum Role {
  USER = 'USER',
  ADMIN = 'ADMIN',
}

/**
 * Onboarding status enumeration
 * Tracks the state of user's onboarding process with Didit
 */
export enum OnboardingStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

/**
 * User interface
 * Represents the user document structure in Firestore
 */
export interface User {
  uid: string;
  email: string;
  role: Role;
  onboardingCompleted: boolean;
  onboardingStatus: OnboardingStatus;
  diditWorkflowId?: string;
  createdAt: Date;
  updatedAt: Date;
}

/**
 * Create user DTO (Data Transfer Object)
 * Used when creating a new user in Firestore
 */
export interface CreateUserDto {
  uid: string;
  email: string;
  role?: Role;
  onboardingCompleted?: boolean;
  onboardingStatus?: OnboardingStatus;
  diditWorkflowId?: string;
}
